export const LayoutActions = {
  SET_DISPLAY_NAVBAR: 'setDisplayNavBar',
  SET_DISPLAY_MENU: 'setDisplayMenu',
  TOGGLE_DISPLAY_MENU: 'toggleDisplayMenu',
  SET_HEADER_ELEMENTS: 'setHeaderElements',
};

export const setDisplayNavBar = (display) => ({
  type: LayoutActions.SET_DISPLAY_NAVBAR,
  payload: display,
});

export const setDisplayMenu = (menu) => ({
  type: LayoutActions.SET_DISPLAY_MENU,
  payload: menu,
});

export const toggleDisplayMenu = () => ({
  type: LayoutActions.TOGGLE_DISPLAY_MENU
});

export const setHeaderElements = (elements) => ({
  type: LayoutActions.SET_HEADER_ELEMENTS,
  payload: elements,
});
